import { render, staticRenderFns } from "./ColumnEditDialog.vue?vue&type=template&id=2ed20d40&scoped=true&"
import script from "./ColumnEditDialog.vue?vue&type=script&lang=js&"
export * from "./ColumnEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./ColumnEditDialog.vue?vue&type=style&index=0&id=2ed20d40&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed20d40",
  null
  
)

export default component.exports